<app-modal #modal [customClassName]="'add-note-modal'">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Add Expense Claim Note</h2>
    </div>
    <div class="modal-body">
      <form [formGroup]="addNoteForm">
        <label class="label-input">Note</label>
        <textarea class="form-control" formControlName="notes"></textarea>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="Cancel"
                      variant="secondary"
                      width="fill"
                      (clicked)="closeAddNoteModal()" />
        </div>

        <div class="col-6">
          <app-button text="Continue"
                      [disabled]="addNoteProcessing"
                      [isBusy]="addNoteProcessing"
                      variant="secondary"
                      width="fill"
                      (clicked)="addNoteToExpenseClaim()" />
        </div>
      </div>
    </div>
  </div>
</app-modal>
